import React from "react";

import ContentLoader from 'react-content-loader';

function LoadingSquares() {
  return (<>
    <ContentLoader
        speed={3}
        width={215}
        height={50}
        viewBox="0 0 215 50"
        backgroundColor="#696969"
        foregroundColor="#363636"
        style={{ width: "100%", height: "auto" }}
    >
        <circle cx="31" cy="31" r="15" />
        <rect x="0" y="0" rx="2" ry="2" width="50" height="50" />
        <rect x="55" y="0" rx="2" ry="2" width="50" height="50" />
        <rect x="110" y="0" rx="2" ry="2" width="50" height="50" />
        <rect x="165" y="0" rx="2" ry="2" width="50" height="50" />
    </ContentLoader>
  </>);
}

export default LoadingSquares;
